import React from 'react'
import { LinearProgress } from '@mui/material'
import CheckInListItem from '@tabeeb/modules/checkIns/components/CheckInsList/CheckInListItem'
import { Caption, Stack } from '@collaborate-health/uikit'
import { StyledList } from './CheckInsList.styles'
import { CheckInsListProps } from './CheckInsList.types'

const CheckInsList: React.FC<CheckInsListProps> = ({
  checkIns,
  hasNextPage,
  isFetchingNextPage,
  viewType,
  sentinelRef,
}) => {
  return (
    <Stack spacing={2}>
      <StyledList>
        {checkIns &&
          checkIns.pages
            .flatMap((p) => p.Users ?? [])
            .map((user) => <CheckInListItem key={user.Id} user={user} viewType={viewType} />)}

        <li>
          <div ref={sentinelRef as React.RefObject<HTMLDivElement>} style={{ height: 24 }} />
        </li>
      </StyledList>

      {isFetchingNextPage && <LinearProgress />}
      {!hasNextPage && (
        <Stack justifyContent='center'>
          <Caption textAlign='center'>No more items to show</Caption>
        </Stack>
      )}
    </Stack>
  )
}

export default CheckInsList

